import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap';

export const CommentInput = ({
    value,
    onChange,
    disabled,
    id
}) => (
    <FormGroup className="mt-4 mb-3">
        <Label
            for={id}
            className="form-label standard-text"
        >
            Комментарий к обработке
        </Label>

        <Input
            type="textarea"
            id={id}
            value={value}
            onChange={onChange}
            placeholder="Напишите комментарий к обработке файлов..."
            disabled={disabled}
            rows={3}
            className="text-input standard-bg standard-text"
        />
    </FormGroup>
);